import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import logo1 from "../Assets/img/phantom.svg";
import logo2 from "../Assets/img/logo-36.png";
import logo3 from "../Assets/logo3.png";
import logo4 from "../Assets/img/logo-33.svg";
import logo5 from "../Assets/logo5.png";
import logo6 from "../Assets/img/logo-34.svg";
import logo7 from "../Assets/img/logo-35.png";
import logo8 from "../Assets/img/s.svg";
const wallets = [
  {
    name: "Slush",
    logo: logo8,
  },
  {
    name: "Phantom ",
    logo: logo1,
  },

  {
    name: "Nightly",
    logo: logo4,
  },
  {
    name: "Bybit Wallet",
    logo: logo6,
  },

  {
    name: "Gate Wallet",
    logo: logo7,
  },
  {
    name: "OKX Wallet",
    logo: logo5,
  },

  {
    name: "Backpack",
    logo: logo2,
  },

  {
    name: "WalletConnect",
    logo: logo3,
    alt: true,
  },
];

export default function ConnectWalletModal({
  isOpen,
  onClose,
  setShowModal2,
  setShowModal3,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="relative w-full max-w-md p-4 text-white bg-[#0E1831] rounded-lg shadow-xl md:max-w-2xl"
          >
            <button
              className="absolute text-gray-400 top-5 right-5 hover:text-white"
              onClick={onClose}
            >
              <FaTimes />
            </button>

            <div className="">
              <p className="mb-5 text-sm text-left text-gray-300">
                Select wallet
              </p>
            </div>

            <div className="grid grid-cols-1 gap-3">
              {wallets.map((wallet, i) => (
                <button
                  key={i}
                  onClick={() => {
                    if (wallet?.alt) {
                      onClose();
                      setShowModal3(true);
                    } else {
                      onClose();
                      setShowModal2(true);
                    }
                  }}
                  className="w-full flex items-center gap-3 px-4 py-2 bg-[#121f3f] hover:bg-[#0d1630] rounded-md transition text-white"
                >
                  <img
                    src={wallet.logo}
                    alt={wallet.name}
                    className="object-cover rounded-full w-9 h-9"
                  />
                  <span className="text-sm">{wallet.name}</span>
                </button>
              ))}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
